import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'index',
        component: () => import('../views/pages/index.vue')
      },
      {
        path: 'detail',
        component: () => import('../views/pages/detail.vue')
      }
    ]
  },
  {
    path: '/404',
    name: '404page',
    component: () => import('@/views/test.vue')
  },
  // 未知路由重定向
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
export default router
